import { render, staticRenderFns } from "./ExtraCosts.vue?vue&type=template&id=5e6baff2&scoped=true&"
import script from "./ExtraCosts.vue?vue&type=script&lang=ts&"
export * from "./ExtraCosts.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraCosts.vue?vue&type=style&index=0&id=5e6baff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6baff2",
  null
  
)

export default component.exports